 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React, {useMemo} from 'react'
import {useFragment, usePreloadedQuery} from 'react-relay'
import {EmptyDropdownMenuItemLabel} from '~/components/EmptyDropdownMenuItemLabel'
import {SearchMenuItem} from '~/components/SearchMenuItem'
import useSearchFilter from '~/hooks/useSearchFilter'

import DropdownMenuLabel from '../../../../components/DropdownMenuLabel'
import Menu from '../../../../components/Menu'
import MenuAvatar from '../../../../components/MenuAvatar'
import MenuItem from '../../../../components/MenuItem'
import MenuItemLabel from '../../../../components/MenuItemLabel'
import useAtmosphere from '../../../../hooks/useAtmosphere'

import UpdateTaskMutation from '../../../../mutations/UpdateTaskMutation'
import avatarUser from '../../../../styles/theme/images/avatar-user.svg'



const StyledPreferredName = styled('div')({
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden'
})







const gqlQuery = graphql`
  query TaskFooterUserAssigneeMenuQuery($teamId: ID!) {
    viewer {
      id
      team(teamId: $teamId) {
        teamId: id
        teamMembers(sortBy: "preferredName") {
          id
          picture
          preferredName
          userId
        }
      }
    }
  }
`
const TaskFooterUserAssigneeMenu = (props) => {
  const {area, menuProps, task: taskRef, queryRef} = props
  const task = useFragment(
    graphql`
      fragment TaskFooterUserAssigneeMenu_task on Task {
        id
        userId
        team {
          id
        }
      }
    `,
    taskRef
  )
  const data = usePreloadedQuery(gqlQuery, queryRef)
  const {viewer} = data

  const {userId, id: taskId} = task
  const {team} = viewer
  const atmosphere = useAtmosphere()
  const teamMembers = _optionalChain([team, 'optionalAccess', _ => _.teamMembers]) || []
  const taskUserIdx = useMemo(
    () => teamMembers.findIndex(({userId}) => userId) + 1,
    [userId, teamMembers]
  )
  const assignees = useMemo(
    () => teamMembers.filter((teamMember) => teamMember.userId !== userId),
    [userId, teamMembers]
  )
  const handleTaskUpdate = (newAssignee) => () => {
    const newUserId = newAssignee.userId === userId ? null : newAssignee.userId
    UpdateTaskMutation(atmosphere, {updatedTask: {id: taskId, userId: newUserId}, area}, {})
  }

  const {
    query,
    filteredItems: matchedAssignees,
    onQueryChange
  } = useSearchFilter(assignees, (assignee) => assignee.preferredName)

  if (!team) return null
  return (
    React.createElement(Menu, {
      keepParentFocus: true,
      ariaLabel: 'Assign this task to a teammate',
      defaultActiveIdx: userId ? taskUserIdx : undefined,
      ...menuProps,}

      , React.createElement(DropdownMenuLabel, null, "Assign to:" )
      , assignees.length > 5 && (
        React.createElement(SearchMenuItem, { placeholder: "Search team members"  , onChange: onQueryChange, value: query,} )
      )
      , query && matchedAssignees.length === 0 && (
        React.createElement(EmptyDropdownMenuItemLabel, { key: "no-results",}, "No team members found!"

        )
      )
      , matchedAssignees.map((assignee) => {
        return (
          React.createElement(MenuItem, {
            key: assignee.id,
            label: 
              React.createElement(MenuItemLabel, null
                , React.createElement(MenuAvatar, { alt: assignee.preferredName, src: assignee.picture || avatarUser,} )
                , React.createElement(StyledPreferredName, null, assignee.preferredName)
              )
            ,
            onClick: handleTaskUpdate(assignee),}
          )
        )
      })
    )
  )
}

export default TaskFooterUserAssigneeMenu
